<template>
  <div class="relevance">
    <el-button type="text" size="medium" @click="$router.go(-1)">返回</el-button><br>
    <el-button type="primary" @click="addcourseHandel()">添加</el-button>
    <el-row>
      <el-table v-loading="loading" :data="tableData" border size="mini" :stripe="true"
        style="width: 100%; margin: 10px 0">
        <el-table-column label="课程ID" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div>{{ row.target_id }}</div>
          </template>
        </el-table-column>
        <el-table-column label="课程名称" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div>{{ row.title }}</div>
          </template>
        </el-table-column>
        <el-table-column label="价格（元）" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div>{{ row.price }}</div>
          </template>
        </el-table-column>
        <el-table-column label="分润金额（元）" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <div>{{ row.rebate_amount }}</div>
          </template>
        </el-table-column>
        <el-table-column label="分享海报" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <img :src="row.share_img_url" alt="" @click.stop="amplificationHandel(row.share_img_url)" style="width: 100%; height: 115px;">
          </template>
        </el-table-column>
        <el-table-column label="客服二维码" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <img :src="row.custom_service_url" alt="" style="width: 100%; height: 115px;" @click.stop="amplificationHandel(row.custom_service_url)">
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button @click="updateHandel(row.status, row.id)" size="mini" type="text" style="color: #409eff;">{{ row.status ? '下架' : '上架' }}</el-button>
            <el-button @click="handleRowClick(row.id)" size="mini" type="text" style="color: #409eff;">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <div class="bott">
      <el-pagination background layout="prev, pager, next" :total="totalItems" :page-size="pageSize"
        :current-page="currentPage" @current-change="handlePageChange">
      </el-pagination>
    </div>
    <el-dialog  :visible.sync="dialogVisibleimg" width="30%" :before-close="handleClose" >
      <div class="dialogimg">
        <img :src="dialogimg" alt="">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRelationshipList, updateRelationshipStatus } from "@/api/distribution";
export default {
  name: '',
  data() {
    return {
      tableData: [{
        id: 2,//该行关系ID
        item_type: 2,
        target_id: 102053,//对象课程ID
        rebate_amount: "15.00",//分润金额
        share_img_url: "https:\/\/www.baidu.com\/img\/PCtm_d9c8750bed0b3c7d089fa7d55720d6cf.png",
        custom_service_url: "https:\/\/www.baidu.com\/img\/PCtm_d9c8750bed0b3c7d089fa7d55720d6cf.png",
        status: 1,//状态，0-当前下架，1-当前上架
        title: "轻安喜悦 自在入眠",//课程标题
        price: "1.10",//安卓价

      }],
      id: null,
      loading: true,
      page: 1,
      limit: 10,
      currentPage: 1, // 当前页
      pageSize: 10, // 一页几条
      totalItems: 0,
      dialogVisibleimg:false,
      dialogimg:'',
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.getlist()
  },
  methods: {
    addcourseHandel() {
      this.$router.push(`/distribution/addcourse?id=${this.id}`)

    },
    getlist() {
      getRelationshipList({ activity_distribution_id: this.id, page: this.page, limit: this.limit }).then((res) => {
        this.tableData = res.data.list
        this.totalItems = res.data.total
        this.loading = false
      })
    },
    updateHandel(v, id) {
      console.log(v);
      let status = null
      if (v) { status = 0 } else { status = 1 }
      updateRelationshipStatus({ id, status }).then((res) => {
        if (res.code) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.getlist()
        }
      })
    },
    handlePageChange(currentPage) {
      this.page = currentPage
      this.getlist()
    },
    handleRowClick(id) {
      this.$router.push(`/distribution/addcourse?id=${this.id}&rowid=${id}`)
    },
    amplificationHandel(row) {
      console.log('fangfa',row);
      this.dialogimg = row
      this.dialogVisibleimg = true
    },
    handleClose(){
      this.dialogVisibleimg = false
      this.dialogimg = ''
    },
  },
}
</script>

<style>
.relevance {
  cursor: pointer;
  padding: 0 20px;
}
 .relevance .dialogimg {
  width: 100%;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.relevance .dialogimg img{
width: 400px;
height: 100%;
object-fit: cover;
display: block;
}
</style>
